import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import VideoCall from './pages/VideoCall';
import Appointments from './pages/Appointments';
import NewAppointment from './pages/NewAppointment';
import RescheduleAppointment from './pages/RescheduleAppointment';
import DoctorDirectory from './pages/DoctorDirectory';
import Profile from './pages/Profile';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/video-call/:appointmentId" 
                element={
                  <PrivateRoute>
                    <VideoCall />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/appointments" 
                element={
                  <PrivateRoute>
                    <Appointments />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/appointments/new" 
                element={
                  <PrivateRoute>
                    <NewAppointment />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/appointments/:id/reschedule" 
                element={
                  <PrivateRoute>
                    <RescheduleAppointment />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/doctors" 
                element={
                  <PrivateRoute>
                    <DoctorDirectory />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/profile" 
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                } 
              />
            </Routes>
          </main>
          <Footer />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
